import { apiRequest, postApiRequest } from './_tools';

export function fetchCampaigns({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/campaignsWithPaging?page=${page}&itemsPerPage=${itemsPerPage}` +
    `&videoExistence=${filter.videoExistence}` +
    `&cityExistence=${filter.cityExistence}` +
    `&active=${filter.active}` +
    `&country=${filter.country}` +
    `&platform=${filter.platform}` +
    `&id=${filter.id}` +
    `&externalId=${filter.externalId}` +
    `&name=${filter.name}` +
    `&reason=${filter.reason}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchCampaignsByCountry() {
  return apiRequest('/api/campaignsByCountry')
    .catch(({ error }) => Promise.reject(error));
}

export function fetchCampaignsByCategory() {
  return apiRequest('/api/campaignsByCategory')
    .catch(({ error }) => Promise.reject(error));
}

export function fetchCampaignDetails(campaignId) {
  return apiRequest(`/api/campaigns/${campaignId}`)
    .catch(({ error }) => Promise.reject(error));
}

export function updateCampaign({ campaignId, revShare, capping }) {
  return postApiRequest(`/api/campaigns/${campaignId}`, { revShare, capping })
    .catch(({ error }) => Promise.reject(error));
}

export function fetchCampaignsNames() {
  return apiRequest('/api/campaigns/names')
    .catch((error) => Promise.reject(error));
}

export function fetchCampaignsIds() {
  return apiRequest('/api/campaigns/ids')
    .catch((error) => Promise.reject(error));
}

export function fetchCampaignsCountries() {
  return apiRequest('/api/campaigns/countries')
    .catch((error) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/campaigns.js
 **/